import { ApiService } from "Services/ApiService";
import { ResultsDTO } from "Types/ResultsDTO";

export interface ActiveAuthor {
  id: number;
  author: string;
  isActive: string;
}

interface AuthorsByCategoryResult {
  authorCount: number;
  authors: string[];
}

export const activeAuthorApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getAllActiveAuthors: builder.query<ActiveAuthor[], void>({
      query: () => ({
        url: "author/active-authors",
        method: "GET",
      }),
      transformResponse: (res: ResultsDTO<ActiveAuthor[]>) => res.results ?? [],
      providesTags: [{ type: "Author", id: "ACTIVE_LIST" }],
    }),
    getAuthorsByCategory: builder.query<string[], string>({
      query: (categoryId) => ({
        url: "author/by-category",
        params: { categoryId },
      }),
      transformResponse: (res: ResultsDTO<AuthorsByCategoryResult>) =>
        res.results?.authors ?? [],
      providesTags: (result, error, categoryId) => [
        { type: "Author", id: `CATEGORY_${categoryId}` },
      ],
    }),
  }),
});

export const { useGetAllActiveAuthorsQuery, useGetAuthorsByCategoryQuery } =
  activeAuthorApiSlice;
